import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import Container from "@/components/base/Container";
import type { Article } from "@/types/content";
import { getCategoryName } from "@/utils/content";

interface RelatedListProps {
  article: Article;
  related: Article[];
}

export default function RelatedList({ article, related }: RelatedListProps) {
  if (related.length === 0) return null;
  return (
    <section className="border-t border-background-200 bg-background-100 py-12 md:py-16">
      <Container>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
              相关推荐
            </span>
            <h2 className="mt-3 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              继续读：{getCategoryName(article.category)}方向的几篇
            </h2>
          </div>
          <Link
            to="/topics"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            全部盘点
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {related.map((item) => (
            <ArticleCard key={item.id} article={item} />
          ))}
        </div>
      </Container>
    </section>
  );
}